import React from 'react';

class SubRecord extends React.Component {
  constructor(props) {
    super(props);

    this.onExpand = this.onExpand.bind(this);

    this.state =  {
      expanded: false
    };
  }

  onExpand() {
    this.setState({
      expanded: !this.state.expanded
    });
  }

  render() {
    const { expanded } = this.state;

    return (
      <section className="record-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-2 section-lefthead"
              style={{"backgroundColor": this.props.color, "borderColor": this.props.color }}
            >
              <h3 className="section-title"> {this.props.title} </h3>
            </div>
            <div className="col-md-10 section-righttail" style={{"borderColor": this.props.color }}>
              <button onClick={ this.onExpand }
                className="btn btn-default readmore-button pull-right country-profile-section__expand"
              >
                {expanded ? "Collapse" : "Expand"}
                <span className={expanded ? null : "caret"} ></span>
              </button>
              <div className={ this.state.expanded ? "expanded-countryprofile" : null  }>
                { /* The actual content of this component is passed via its children: */ }
                { this.props.children }
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default SubRecord;



// WEBPACK FOOTER //
// ./src/components/CountryProfile/CountryProfileSubRecord.js